import { createRoot } from 'react-dom/client';
import React, { lazy, Suspense } from 'react';
import 'regenerator-runtime/runtime';

import * as Sentry from '@sentry/react';

import './style.css';
import FullPageLoader from './components/FullPageLoader';

const cssRule =
  'color: rgb(249, 162, 34);' +
  'font-size: 30px;' +
  'font-weight: bold;' +
  'text-shadow: 1px 1px 5px rgb(249, 162, 34);' +
  'filter: dropshadow(color=rgb(249, 162, 34), offx=1, offy=1);';

const cssRuleDescription = 'color: rgb(0, 0, 0);' + 'font-size: 18px;';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

setTimeout(console.info.bind(console, '%cAVISO', cssRule), 0);
setTimeout(
  console.info.bind(
    console,
    '%cO uso deste console talvez permita que invasores falsifiquem sua identidade e roubem informações por meio de um ataque chamado Self-XSS.Não digite nem cole códigos que você não conhece.',
    cssRuleDescription
  ),
  0
);

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['log', 'info', 'warn', 'error', 'debug', 'assert'],
    }) as any,
    Sentry.consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
    Sentry.replayIntegration(),
  ],
  // @ts-ignore
  environment: process.env.NODE_ENV || import.meta.env.NODE_ENV,
  enabled: Boolean(Number(import.meta.env.VITE_SENTRY_ENABLED)),
  enableLogs: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const userAgent = navigator.userAgent;
Sentry.getCurrentScope().setExtra('User Agent', userAgent);

const LazyApp = lazy(() => import('./app'));

const Wrapper = () => {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <LazyApp />
    </Suspense>
  );
};

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<Wrapper />);
